import { render, staticRenderFns } from "./NewLgbTeamMembersEdit.vue?vue&type=template&id=1230b86b"
import script from "./NewLgbTeamMembersEdit.vue?vue&type=script&lang=js"
export * from "./NewLgbTeamMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./NewLgbTeamMembersEdit.vue?vue&type=style&index=0&id=1230b86b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports